import QRPeriodDisplay from './QRPeriodDisplay'
export default QRPeriodDisplay